<template>
    <PropertiesEditorBase class="widget-properties-editor-input-date" name="input date"
        :fields="['label', 'placeholder', 'creation-date']" v-model:widget="widgetRef">
    </PropertiesEditorBase>
</template>

<script setup>
import { useVModel } from '@vueuse/core';

import PropertiesEditorBase from './PropertiesEditorBase.vue';

const props = defineProps({
    widget: {
        type: Object,
        required: true,
    },
});
const emit = defineEmits(['update:widget']);

const widgetRef = useVModel(props, 'widget', emit);

console.log('PROPERTIES EDITOR INPUT DATE: ', widgetRef.value);
</script>
